const apisHelper = {
  /**
   *
   * @param {Object} params
   * @param {Object} pagination
   * @returns {Object}
   */
  setupParams(params, pagination) {
    if (!params) return {};
    const obj = Object.assign({}, params);
    if (pagination) {
      Object.keys(pagination).forEach((k) => {
        obj[`pagination.${k}`] = pagination[k];
      });
    }
    return obj;
  },
  /**
   *
   * @param {Object} pagination
   * @returns {Object}
   */
  setupPagination(pagination) {
    const obj = {};
    Object.keys(pagination).forEach((k) => {
      if (pagination[k]) obj[`pagination.${k}`] = pagination[k];
    });
    return obj;
  },
  /**
   * Build transaction query string for SDK 0.50 format
   * @param {Object|String} events - Events object with key-value pairs or string query
   * @returns {String} - Formatted query string
   * @example
   * // Object format
   * buildTxQuery({ 'message.action': 'send', 'message.sender': 'cosmos1...' })
   * // Returns: "message.action='send' AND message.sender='cosmos1...'"
   *
   * // String format (passthrough)
   * buildTxQuery("message.action='send' AND tx.height>1000")
   * // Returns: "message.action='send' AND tx.height>1000"
   */
  buildTxQuery(events) {
    // If already a string, return as-is
    if (typeof events === 'string') {
      return events;
    }

    // If not an object or null/undefined, return empty string
    if (!events || typeof events !== 'object') {
      return '';
    }

    // Build query from object
    const conditions = Object.entries(events)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        // Wrap value in quotes if it's a string
        const formattedValue = typeof value === 'string' ? `'${value}'` : value;
        return `${key}=${formattedValue}`;
      });

    return conditions.join(' AND ');
  },
};

export default apisHelper;
